// 存储当前行的衣物列表数据
export default {
  namespaced: true,
  state: {
    rowData: {},//当前行的数据容器
  },
  mutations: {
    changeRowDataClothing(state, payload) {
      state.rowData = payload
    }
  }
}